import { ReservationOccasion } from '../../../../../services/exports/Constants';

export default {
  updated_details: 'Detalles actualizados',
  previous_details: 'Detalles anteriores',
  fields: {
    datetime: 'Fecha:',
    email: 'Correo:',
    phone_number: 'Teléfono:',
    customer: 'Cliente:',
    source: 'Fuente:',
    guests: 'Comensales:',
    comment: 'Comentario:',
    confirmed_at: 'Confirmado el:',
    status: 'Estado:',
    occasion: 'Ocasión:',
    created_at: 'Creado el:',
  },
  status: {
    confirmed: 'Confirmado',
    pending: 'Esperando aprobación',
    canceled: 'Cancelado',
    canceled_by_customer: 'Cancelado por el cliente',
    rejected: 'Rechazado',
    removed: 'Eliminado',
  },
  buttons: {
    confirm: 'Confirmar',
    reject: 'Rechazar',
    cancel: 'Cancelar',
    edit: 'Editar',
    remove: 'Eliminar',
  },
  occasion: {
    [ReservationOccasion.Birthday]: 'Cumpleaños',
    [ReservationOccasion.Anniversary]: 'Aniversario',
    [ReservationOccasion.Date]: 'Cita',
    [ReservationOccasion.SpecialOccasion]: 'Ocasión especial',
    [ReservationOccasion.BusinessMeal]: 'Comida de negocios',
  },
  remove_reservation_modal: {
    title: '¿Estás seguro de que deseas eliminar la reserva?',
    buttons: {
      remove: 'Eliminar',
      cancel: 'Cancelar',
    },
  },
  response_messages: {
    success: 'Estado de la reserva actualizado correctamente. El cliente ha sido notificado.',
    error: 'Error al actualizar el estado de la reserva. Inténtalo de nuevo.',
  },
};
